import React from 'react'
import intl from 'react-intl-universal'
import CONSTANTS from '~/constants'

// eslint-disable-next-line @typescript-eslint/no-var-requires
const cx = require('./styles.scss')

interface ClonedStories {
  relatedContent?: any
}

const MAX_STORIES_TO_DISPLAY = 2

const ClonedStories: React.FC<ClonedStories> = ({
  relatedContent,
}: ClonedStories) => {
  const [storiesDisplayed, setStoriesDisplayed] = React.useState(
    MAX_STORIES_TO_DISPLAY
  )

  const clonedFromParent = relatedContent?.clonedFromParent || []
  const clonedChildren = relatedContent?.clonedChildren || []

  const clonedAmmountDifference: number =
    clonedChildren.length - storiesDisplayed

  const storyId: string =
    clonedFromParent[0]?.referent?.id ?? clonedFromParent[0]?._id

  return (
    <>
      {clonedFromParent.length > 0 && (
        <div>
          {intl.get('publishActions.panel.clonedFrom')}
          <a
            href={`${CONSTANTS.TRIDENT_ROUTE_COMPOSER_UI}/edit/${storyId}`}
            target="_blank"
            rel="noreferrer"
          >
            {storyId}
          </a>
        </div>
      )}

      {clonedChildren.length > 0 && (
        <div>
          {intl.get('publishActions.panel.clonedTo')}{' '}
          {clonedChildren.slice(0, storiesDisplayed).map((c, index) => (
            <React.Fragment key={c.referent.id}>
              <a
                href={`${CONSTANTS.TRIDENT_ROUTE_COMPOSER_UI}/edit/${
                  c?.referent?.id ?? c?._id
                }`}
                target="_blank"
                rel="noreferrer"
              >
                {c?.referent?.id ?? c?._id}
              </a>
              {index + 1 < clonedChildren.slice(0, storiesDisplayed).length && (
                <span>, </span>
              )}
            </React.Fragment>
          ))}{' '}
          {clonedChildren.length > MAX_STORIES_TO_DISPLAY && (
            <button
              type="button"
              className={`btn-link ${cx.viewMoreLessLink}`}
              onClick={() => {
                setStoriesDisplayed(
                  clonedChildren.length === storiesDisplayed
                    ? MAX_STORIES_TO_DISPLAY
                    : clonedChildren.length
                )
              }}
              data-testid="view-more-less-cloned"
            >
              {clonedChildren.length === storiesDisplayed
                ? `-${intl.get('PublishActions.clonedToCreateList.viewLess')}`
                : ` + ${clonedAmmountDifference} ${intl.get(
                    'PublishActions.clonedToCreateList.more'
                  )}`}
            </button>
          )}
        </div>
      )}
    </>
  )
}

export default ClonedStories
